<div [ngClass]="{'buttonContainer': true, 'disabledButton': disabled != null}">
  {{ text }}
</div>
